<template>
  <v-container fluid>
    <p class="process-repair-tab-section-title ma-4">{{$t("pages.repair.generalReport")}}</p>
    <v-row dense no-gutters>
      <v-col>
        <report-filter @filter="tryToFilterRepairs"/>
      </v-col>
    </v-row>
    <v-row dense no-gutters class="mt-5">
      <v-col class="pa-4">
        <main-data-table
        ref="tableRef"
        number-pages
        :headers="headers"
        :items="items"
        :page.sync="page"
        :size.sync="size"
        :loading="isLoading"
        @fetch="tryToFetchRepairs"
        :sort-by.sync="sortBy"
        :sort-dir.sync="sortDir"
        :total-elements="totalElements"
        :with-search="false">
          <template v-slot:[`header.createdAt`]="{ header }">
            {{$t(header.text, {'0': getTimeZoneInNumber(new Date())})}}
          </template>
          <template v-slot:[`header.updatedAt`]="{ header }">
            {{$t(header.text, {'0': getTimeZoneInNumber(new Date())})}}
          </template>

          <template v-slot:[`item.requestId`]="{ item }">
              <span>
                {{item.requestId}}
              </span>
          </template>
          <template v-slot:[`item.status`]="{ item }">
              <span>
                {{$t(getStatus(item.status))}}
              </span>
          </template>
          <template v-slot:[`item.createdAt`]="{ item }">
              <span>
                {{getDateNewYorkFormat(item.createdAt)}}
              </span>
          </template>
          <template v-slot:[`item.updatedAt`]="{ item }">
              <span>
                {{getDateNewYorkFormat(item.updatedAt)}}
              </span>
          </template>
          <template v-slot:[`item.clientUsername`]="{ item }">
              <span>
                {{item.clientUsername}}
              </span>
          </template>
          <template v-slot:[`item.serviceUsername`]="{ item }">
              <span>
                {{item.serviceUsername}}
              </span>
          </template>
          <template v-slot:[`item.details`]="{ item }">
            <route-btn
            :href="`process-repair/${item.id}`"
            target="blank"
            label="btns.viewDetails"
            :width="120"
            :height="30"/>
          </template>
        </main-data-table>
      </v-col>
    </v-row>

    <export-xlsx-row
    :width="150"
    :height="50"
    :disabled="items.length === 0"
    :loading.sync="isLoading"
    class="px-4"
    name="export.title.generalReport"
    :exporter="getExporter"/>
  </v-container>
</template>
<script>
import { getRepairStatusByKey } from '@/utils/statusesUtil'
import { fetchRepairsByFilter } from '@/repositories/repairRepo'
import { exportGeneralReportXlsx } from '@/repositories/exportRepo'
import ReportFilter from '@/components/report/ReportFilter'
import ExportXlsxRow from '@/components/common/ExportXlsxRow'
import DateUtil from '@/utils/DateUtil'
import { execHttpRequestThrowable } from '@/services/http'
import MainDataTable from '@/components/common/MainDataTable'
import RouteBtn from '@/components/btns/RouteBtn'
export default {
  components: {
    ReportFilter,
    MainDataTable,
    RouteBtn,
    ExportXlsxRow
  },
  data() {
    return {
      headers: [
        {
          text: 'headers.requestId',
          align: 'start',
          sortable: true,
          value: 'requestId',
          columnName: "request_id"
        }, {
          text: 'headers.client',
          align: 'start',
          sortable: true,
          value: 'clientUsername',
          columnName: "client_access_identification"
        }, {
          text: 'headers.service',
          align: 'start',
          sortable: true,
          value: 'serviceUsername',
          columnName: "service_access_identification"
        }, {
          text: 'headers.status',
          align: 'start',
          sortable: true,
          value: 'status'
        }, {
          text: 'headers.creationDateTime',
          align: 'start',
          sortable: true,
          value: 'createdAt', //(yyyy-MM-dd HH:mm)
          columnName: "created_at"
        }, {
          text: 'headers.lastChangeDateTime',
          align: 'start',
          sortable: true,
          value: 'updatedAt', //(yyyy-MM-dd HH:mm)
          columnName: "updated_at"
        }, {
          text: 'headers.details',
          align: 'start',
          sortable: false,
          value: 'details'
        }
      ],
      sortBy: "createdAt",
      sortDir: "DESC",
      items: [],
      totalElements: 0,
      size: 10,
      page: 1,
      filterData: null,
      isLoading: false
    }
  },
  computed: {
    getExporter() {
      return async () => await exportGeneralReportXlsx(this.getDataAsBody(), this.getSort)
    },
    getSort() {
      return `${this.$refs.tableRef.getColumnNameByHeaderValue(this.sortBy)},${this.sortDir}`
    }
  },
  methods: {
    async tryToFilterRepairs(f) {
      this.filterData = f
      this.page = 1
      await this.tryToFetchRepairs({
        size: this.size,
        page: 1,
        sort: this.getSort
      })
    },
    async tryToFetchRepairs({size, page, sort}) {
      const DATA = this.getDataAsBody()
      const r = await execHttpRequestThrowable(async () => await fetchRepairsByFilter(DATA, size, page - 1, sort),
      {},
      v => this.isLoading = v)
      const p = r.response.data
      this.totalElements = p.totalElements
      this.items = [...p.content]
    },
    getDataAsBody() {
      return {
        clientId: this.filterData.client ? this.filterData.client.id : null,
        serviceId: this.filterData.service ? this.filterData.service.id : null,
        partId: this.filterData.part ? this.filterData.part.id : null,
        categoryId: this.filterData.category ? this.filterData.category.id : null,
        status: this.filterData.status ? this.filterData.status.key : null,
        requestNumber: this.filterData.requestNumber,
        serialNumber: this.filterData.serialNumber,
        serviceTag: this.filterData.serviceTag,
        createdFrom: this.filterData.createdFrom ? new Date(this.filterData.createdFrom).toISOString().replaceAll('.000Z', '') : null,
        createdTo: this.filterData.createdTo ? new Date(this.filterData.createdTo).toISOString().replaceAll('.000Z', '') : null
      }
    },
    getDateNewYorkFormat(d) {
      return DateUtil.getDateNewYorkFormat(d)
    },
    getStatus(k) {
      return getRepairStatusByKey(k)
    },
    getTimeZoneInNumber(d) {
      return DateUtil.getTimeZoneInNumber(d)
    }
  },
  created() {
    this.$feedback.fill("General Report Page", this.$route.path)
  }
}
</script>
<style>
.detail-btn.v-btn.v-btn--is-elevated.v-btn--has-bg.theme--light {
  color: #fff;
  background-color: #4285f4!important;
  border-color: #75a4f0;
  font-family: 'Titillium Web', sans-serif;
  font-weight: 400;
  font-size: 0.65rem;
  letter-spacing: 1px;
}
</style>